var _path, _path2, _path3, _path4, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5C33 25.6116 25.6116 33 16.5 33C7.38839 33 0 25.6154 0 16.5C0 7.3884 7.38839 0 16.5 0C25.6154 0 33 7.3884 33 16.5Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7397 20.0543C10.2364 19.9742 9.89331 20.5613 10.225 20.9464C11.6889 22.6391 13.9573 23.7294 16.5116 23.7294C19.0659 23.7294 21.3343 22.6391 22.7982 20.9464C23.1299 20.5613 22.7868 19.9742 22.2874 20.0543C20.5527 20.3326 18.5932 20.4889 16.5154 20.4889C14.4339 20.4889 12.4705 20.3326 10.7397 20.0543Z",
    fill: "#562912"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5681 14.0039C22.4538 13.9391 22.3165 14.0459 22.3432 14.1717C22.5376 15.1629 23.5174 15.9139 24.6993 15.9139C25.8811 15.9139 26.8571 15.1591 27.0553 14.1717C27.082 14.0459 26.9448 13.9391 26.8304 14.0039C26.2242 14.3432 25.4884 14.5453 24.6993 14.5453C23.9101 14.5491 23.1781 14.347 22.5681 14.0039Z",
    fill: "#562912"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15799 14.0039C6.04362 13.9391 5.90637 14.0459 5.93305 14.1717C6.1313 15.1629 7.10727 15.9139 8.28911 15.9139C9.47094 15.9139 10.4469 15.1591 10.6452 14.1717C10.6681 14.0459 10.5346 13.9391 10.4202 14.0039C9.81407 14.3432 9.08208 14.5453 8.29292 14.5453C7.50376 14.5453 6.76416 14.347 6.15799 14.0039Z",
    fill: "#562912"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4646 19.7968C29.4646 21.1997 28.3247 22.3396 26.9218 22.3396C25.515 22.3396 24.3789 21.1997 24.3789 19.7968C24.3789 18.39 25.5188 17.2539 26.9218 17.2539C28.3247 17.2539 29.4646 18.3938 29.4646 19.7968Z",
    fill: "#E55725"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.60526 19.7968C8.60526 21.1997 7.46537 22.3396 6.06241 22.3396C4.65564 22.3396 3.51953 21.1997 3.51953 19.7968C3.51953 18.39 4.65945 17.2539 6.06241 17.2539C7.46537 17.2539 8.60526 18.3938 8.60526 19.7968Z",
    fill: "#E55725"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalm);
export default __webpack_public_path__ + "static/media/calm.4e6d22776c3813f86bb3005e38003a91.svg";
export { ForwardRef as ReactComponent };